/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */

var $ = require("jquery");
var moment = require('moment');

window.$ = $;
window.jQuery = $;
window.moment = moment;

require("./bootstrap");
require('url-polyfill');
require("bootstrap");
require("select2");
require("magnific-popup");
require("jquery-mousewheel");

//require("malihu-custom-scrollbar-plugin");
require("./jquery.mCustomScrollbar");

window.noUiSlider = require("nouislider");

window.bootbox = require("bootbox");
require("gasparesganga-jquery-loading-overlay");

window.Chart = require("chart.js");
window.ChartDataLabels = require("chartjs-plugin-datalabels");

//Chart.plugins.unregister(ChartDataLabels);

window.toastr = require("toastr");
require("popper.js");

var bsCustomFileInput = require("bs-custom-file-input");
window.bsCustomFileInput = bsCustomFileInput;

var entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;',
  '`': '&#x60;',
  '=': '&#x3D;'
};

window.round299 = function (float) {
  return Math.ceil(round2(float)) - 0.01;
};

window.round2 = function (float) {
  return float.toFixed(2);
};

if (!String.prototype.trim) {
  (function () {
    String.prototype.trim = function () {
      return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    };
  })();
}

window.escapeHtml = function (string) {
  return String(string).replace(/[&<>"'`=\/]/g, function (s) {
    return entityMap[s];
  });
};

window.hexToRgbA = function (hex, opacity) {
  var c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')';
  }
  throw new Error('Bad Hex');
};

window.errorMessage = function (result, separator) {
  return result.errors ? window.errorsList(result.errors).join(separator || ", ") : (result.message || result.error)
};

window.errorsList = function (errors) {
  var list = [];
  for (var k in errors) if (errors.hasOwnProperty(k)) {
    list = list.concat(errors[k]);
  }
  return list;
};

window.confirmRequest = function (message, title, ok, cancel, callback) {
  window.bootbox.confirm({
    title: title,
    message: message,
    buttons: {
      confirm: {
        label: ok,
        className: 'button outline danger-button small'
      },
      cancel: {
        label: cancel,
        className: 'button outline primary-button small'
      }
    },
    callback: function (result) {
      if (result) {
        callback();
      }
    }
  });
};

window.showSuccessMessage = function (message, title, ok, callback) {
  window.bootbox.alert({
    title: title,
    message: message,
    buttons: {
      ok: {
        label: ok,
        className: 'btn-default'
      }
    },
    callback: function (result) {
      if (callback !== undefined)
        callback();
    }
  });
};

window.showErrorMessage = function (message, title, ok, callback) {
  window.bootbox.alert({
    title: title || "Error",
    message: message,
    buttons: {
      ok: {
        label: ok || "OK",
        className: 'btn-default'
      }
    },
    callback: function (result) {
      if (callback !== undefined)
        callback();
    }
  });
};

(function ($) {
  function makePostRequest(url, data, target) {
    var jForm = $('<form style="display: none"></form>');
    jForm.attr('action', url);
    jForm.attr('method', 'post');
    if (target)
      jForm.attr('target', target);
    for (let name in data) if (data.hasOwnProperty(name)) {
      let val = data[name];
      let jInput = $("<input>");
      jInput.attr('name', name);
      jInput.attr('value', val);
      jForm.append(jInput);
    }
    $("body").append(jForm);
    jForm.submit();
  }

  $.fn.send = function (url, method, target) {
    let token = document.head.querySelector('meta[name="csrf-token"]');
    let data = this.data();
    let params = {
      _token: token.content,
      _method: method || this.data('method') || "POST"
    };
    for (let k in data) if (data.hasOwnProperty(k)) {
      if (k.indexOf("param_") === 0) {
        let key = k.split("_", 2)[1];
        params[key] = data[k];
      }
    }
    makePostRequest(url || $(this).data('url') || this.attr("href"), params, target || this.attr("target"));
  };

  $.fn.useForm = function () {
    this.filter("a").on("click", function ($event) {
      $event.preventDefault();
      $(this).send();
    });
    return this;
  };
}($));

var showOverlay =
  window.showOverlay = function () {
    $("body").LoadingOverlay("show");
  };

var hideOverlay =
  window.hideOverlay = function () {
    $("body").LoadingOverlay("hide");
  };

window.throttle = function (fn, wait) {
  var time = Date.now();
  return function () {
    if ((time + wait - Date.now()) < 0) {
      fn();
      time = Date.now();
    }
  }
};

// window.addEventListener('scroll', _.throttle(callback, 1000));
// _.debounce - Grouping a sudden burst of events (like keystrokes) into a single one.
// _.throttle - Guaranteeing a constant flow of executions every X milliseconds. Like checking every 200ms your scroll position to trigger a CSS animation.

// var Sidebar = (function(){
//     var init = function(){
//
//     };
//     return {
//         // here your can put your "public" functions
//         init : init
//     }
// });

// var Greetings = {
//     alertFn: function () {
//         alert('OK');
//     },
//
//     john: {
//         sayHelloToJohn: function() {
//             alert ('Hello John!');
//         }
//     }
// // do something else, etc.
// }
//function A(a){
//    this.varA = a;
//}
//A.prototype = {
//varA : null,
//doSomething : function(){
//    // ...
//}
//}

// var module = ctrl.createModule("collections")

var Images =
  window.Images = {
    maxFileSize: null,
    toUploadErrors: [],
    $form: null,
    $dropZone: null,
    fileObjects: null,
    init: function (size, $form, $dropZone) {
      Images.$form = $form;
      Images.$dropZone = $dropZone;
      Images.maxFileSize = size;

      if ($dropZone) {
        $dropZone.find(".js-file-uploader").change(function ($event) {
          $event.preventDefault();
          //fileObj = null;
          //Images.uploadImg($(this).prop('files'));
          Images.fileObjects = null;
          Images.$dropZone.find(".js-file-placeholder").hide();
          Images.prepare(Images.$dropZone.find(".js-file-uploader").prop('files'))
        });
        $dropZone.on("drop", function ($event) {
          $dropZone.removeClass("dragover");
          $event.preventDefault();
          $event.stopPropagation();
          $dropZone.find(".js-file-uploader").prop('files', $event.originalEvent.dataTransfer.files || $event.originalEvent.target.files).change();
        });
        $dropZone.find('.js-delete-img').on("click", function ($event) {
          Images.$dropZone.removeClass('image-selected');
          Images.$dropZone.find('.js-file-placeholder').css('background-image', '').hide();
          Images.$dropZone.find(".js-file-uploader").val('');
          Images.$dropZone.find(".js-delete-img").hide();
          Images.$dropZone.find(".delete-img-input").val(1).change();
          if (Images.$form) {
            Images.$form.find(".js-collection-title").val('').change();
          }
        });
        $dropZone.on("dragover", function ($event) {
          $event.preventDefault();
          $event.stopPropagation();
          var t = $event.originalEvent.dataTransfer.types;
          if (t.contains) {
            if (!t.contains("application/x-moz-file"))
              return false;
          } else {
            if (t.indexOf("Files") < 0)
              return false;
          }
          $dropZone.addClass("dragover");
          return true;
        });
        $dropZone.on("dragleave", function ($event) {
          $event.preventDefault();
          $event.stopPropagation();
          $dropZone.removeClass("dragover");
        });
      }

      if ($form) {
        $form.on("submit", function ($event) {
          $event.preventDefault();
          Images.proceed();
        });
        $form.find(".js-file-start").click(function ($event) {
          $event.preventDefault();
          Images.proceed();
        });
        $form.addClass('inited');
      }

    },

    prepare: function (files) {
      var imgFileErrors = [];
      Images.fileObjects = [];
      for (var i = files && (files.length - 1); i >= 0; i--) {
        var file = files[i];
        var fileName = file.name;
        var fileExt = fileName.split('.').pop().toLowerCase();
        fileName = shortenString(fileName, 16);
        if (['png', 'gif', 'jpg', 'jpeg', 'webp'].indexOf(fileExt) < 0) {
          imgFileErrors.push(fileName + " - Only files with these extensions are allowed: png, jpg, jpeg, gif, webp");
        } else if (file.size > Images.maxFileSize) {
          imgFileErrors.push('"' + fileName + "\" file is too big. Its size cannot exceed " + Images.maxFileSize);
        } else {
          Images.fileObjects.push(file)
        }
      }
      if (imgFileErrors.length > 0) {
        Images.toUploadErrors = imgFileErrors;
        Images.sendFinal(false);
        return;
      }
      if (Images.fileObjects.length > 0) {

        if (Images.$form && Images.$form.find(".js-collection-title").val().trim() === "") {
          Images.$form.find(".js-collection-title").val(shortenString(Images.fileObjects[0].name, 30, true)).trigger('keyup');
        }
        Images.$dropZone.find(".js-file-placeholder").show();

        if (FileReader && files && files.length) {
          var fr = new FileReader();
          fr.onload = function () {
            Images.$dropZone.find(".delete-img-input").val('');
            Images.$dropZone.find(".js-delete-img").show();
            Images.$dropZone.find('.js-file-placeholder').css('background-image', 'url(' + fr.result + ')').show();
            Images.$dropZone.addClass('image-selected');
          };
          fr.readAsDataURL(files[0]);
        } else if (Images.$form) {
          Images.$form.find(".js-file-selected").text(Images.fileObjects[0].name);
        }
      }
    },

    proceed: function () {
      if (!Images.fileObjects /*&& Images.$form.find(".js-file-uploader").prop('files').length === 0*/) {
        Images.$form.find(".js-file-uploader").click();
      } else {
        if (Images.$form.find(".js-collection-title").val().trim() === "") {
          toastr.error("Title is required!");
          return;
        }
        Images.uploadImg(Images.fileObjects);
      }
    },

    uploadImg: function (flist) {
      if (flist.length === 0) {
        toastr.error("File is empty");
        return false;
      }
      //e.LoadingOverlay("show");
      //Images.toUploadListIndex = 0;
      //Images.toUploadList = flist;
      Images.toUploadErrors = [];
      // lets support only 1 file, for a start
      showOverlay();
      Images.sendFile(flist[0], (Images.$form && Images.$form.find(".js-collection-title").val().trim()) || flist[0].name);
    },

    sendFinal: function (success) {
      Images.fileObjects = null;
      //Images.$form.find(".js-collection-title").val("").trigger('keyup');
      Images.$dropZone.find(".js-file-uploader").val("");
      Images.$dropZone.find(".js-file-placeholder").hide();
      hideOverlay();
      if (Images.toUploadErrors.length > 0) {
        var text = escapeHtml(Images.toUploadErrors.join("\n")).split("\n").join("<br />");
        toastr.error(text);
      }
      if (success)
        document.dispatchEvent(new CustomEvent("imagesUploaded", {"detail": {}}));
    },

    sendFile: function (file, title) {
      var fileName = shortenString(file.name, 16);

      var data = new FormData();
      data.append('images[]', file);
      data.append('title', title);

      showOverlay();
      $.ajax({
        type: "POST",
        url: $("#create-form").attr('action'),
        data: data,
        cache: false,
        processData: false,
        contentType: false,
        dataType: "json",
        success: function (result) {
          hideOverlay();
          if (result.error) {
            Images.toUploadErrors.push(fileName + " - " + result.error);
            Images.sendFinal(false);
          } else {

            document.dispatchEvent(new CustomEvent("imageUploaded", {"detail": result}));

            // if ($(".style_collection_item_wide").length) {
            //     $('.style_collection_item_wide').after($(result.html));
            //     Images.checkCollectionHelper();
            // }
            Images.sendFinal(true);
          }
        },
        error: function (response) {
          var result = response.responseJSON;
          hideOverlay();
          Images.toUploadErrors.push(fileName + " - Upload error: " + errorMessage(result, ", "));
          Images.sendFinal(false);
        }
      });
    },
  };

var Products =
  window.Products = {
    init: function () {

    }
  };

var Collections =
  window.Collections = {
    init: function () {
      $('.collections-page .js-collections-container, .collection-products-page .product-collection').on('click', 'a[data-action=edit]', function ($event) {
        $event.preventDefault();
        if (!+$(this).data('progress')) {
          Collections.edit(
            $(this).data('id'),
            $(this).data('title'),
            $(this).data('preview'),
            $(this).data('image'),
            $(this).closest('.collection-item,.product-collection').find('.js-collection-images .img')
          );
        }
      });
      $('.collection-info-container').on('click', 'a[data-action=delete]', function ($event) {
        $event.preventDefault();
        $('#edit-collection-dialog').modal('hide');
        Collections.delete(
          $(this).data('id'),
          $(this).data('title')
        );
      });

      $('#edit-collection-dialog form').on('submit', function ($event) {
        $event.preventDefault();

        var title = $('#edit-collection-dialog form input[name=title]').val();
        if (title.trim().length === 0) {
          toastr.error("Title is required!");
          return;
        }
        var id = $('#edit-collection-dialog form input[name=id]').val();
        var data = {
          'title': title
        };

        showOverlay();
        $.ajax({
          type: "PUT",
          url: '/collections/' + id,
          data: data,
          cache: false,
          dataType: "json",
          success: function (result) {
            hideOverlay();
            $('#edit-collection-dialog').modal('hide');
            document.dispatchEvent(new CustomEvent("collectionUpdated", {"detail": {id: id, title: title}}));
          },
          error: function (response) {
            hideOverlay();
            var result = response.responseJSON;
            toastr.error(escapeHtml(errorMessage(result, "\n")).split("\n").join("<br />"));
          }
        });
      });
    },
    edit: function (id, title, preview, image, images) {
      Collections.selectImgOnEditDialog(preview, image);
      $('#edit-collection-dialog form input[name=id]').val(id);
      $('#edit-collection-dialog form input[name=title]').val(title).trigger('keyup');

      $('#edit-collection-dialog')
        .modal('show')
        .one('hidden.bs.modal', function () {
          $('#edit-collection-dialog .js-magnific').off('mfpOpen mfpClose')
        });
      var collectionImagesContainer = $('#edit-collection-dialog .collection-images');
      collectionImagesContainer.html('');
      images.each(function () {
        collectionImagesContainer.append($(this).clone());
      });
      collectionImagesContainer.children().removeClass('active');
      collectionImagesContainer.children(":first").addClass('active');
    },
    selectImgOnEditDialog: function (preview, image) {
      $('#edit-collection-dialog .js-magnific')
        .attr('href', image)
        .on('mfpOpen', function () {
          $('#edit-collection-dialog').data('bs.modal')._config.keyboard = false;
        })
        .on('mfpClose', function () {
          $('#edit-collection-dialog').data('bs.modal')._config.keyboard = true;
        });
      $('#edit-collection-dialog .js-preview').css('background-image', 'url(' + preview + ')');
    },
    uploadImage: function (files, uploadUrl, successCallback, errorCallback) {
      var data = new FormData();
      if (files.length === 0)
        return;

      var fileName = files[0].name;
      var fileExt = fileName.split('.').pop().toLowerCase();
      fileName = fileName.length > 16 ? (fileName.substr(0, 16) + "…") : fileName;
      var toUploadErrors = [];

      if (['png', 'gif', 'jpg', 'jpeg', 'webp'].indexOf(fileExt) < 0) {
        toUploadErrors.push(fileName + " - Only files with these extensions are allowed: png, jpg, jpeg, gif, webp");
      }

      if (toUploadErrors.length > 0) {
        showToastErrorMessage(toUploadErrors.join("\n"), true);
        $("#file-uploader").val('')
        if (typeof errorCallback === "function") {
          errorCallback();
        }
        return;
      }

      data.append('images[]', files[0]);

      showOverlay();
      $.ajax({
        type: "POST",
        url: uploadUrl,
        data: data,
        cache: false,
        processData: false,
        contentType: false,
        dataType: "json",
        success: function (result) {
          $("#file-uploader").val("");

          hideOverlay();
          if (result.error) {
            showToastErrorMessage(result.error);
            if (typeof errorCallback === "function") {
              errorCallback();
            }
            return;
          } else {
            if (typeof successCallback === "function") {
              successCallback(result);
            }
          }
        },
        error: function (response) {
          console.error("RESULT", response);
          var result = response.responseJSON;
          hideOverlay();
          showToastErrorMessage(errorMessage(result));
          if (typeof errorCallback === "function") {
            errorCallback();
          }
        }
      });
    },
    delete: function (id, title) {
      confirmRequest(
        "<b>“" + escapeHtml(title) + "” collection will be deleted.</b><br /><br />" +
        "Please note that deleting of published collection will also remove its products from your store. <br />" +
        "<br />" +
        "Be aware the deleted collection could not be restored.", "Remove your Collection",
        "Remove Collection", "Cancel", function () {
          Collections.deleteCollection(id);
        }
      );
    },
    deleteCollection: function (id) {
      showOverlay();
      $.ajax({
        type: "DELETE",
        url: '/collections/' + id,
        cache: false,
        dataType: "json",
        success: function (result) {
          hideOverlay();
          if (window.location.pathname.match(/\/collections\/\d+\/products/)) {
            window.location.href = '/collections/products';
          } else {
            window.location.href = '/collections';
          }
        },
        error: function (response) {
          hideOverlay();
          var result = response.responseJSON;
          toastr.error(escapeHtml(result.error || result.message));
        }
      });
    }
  };

var Pusher =
  window.Pusher = {
    load: function (ready) {
      $.ajax({
        type: "get",
        url: '/messages',
        dataType: "json",
        cache: false,
        success: function (result) {
          $("#messages").mCustomScrollbar("destroy");
          $("#messages").html(result.html);
          $("#messages").mCustomScrollbar({
            theme: "minimal-dark",
            axis: "y"
          });
          Pusher.refresh(result.unread);
        },
        error: function (response) {

        }
      });
    },
    delete: function (id) {
      $('[data-message-id=' + id + ']').remove();
      $.ajax({
        type: "DELETE",
        url: '/messages/' + id,
        data: {},
        dataType: "json",
        success: function (result) {
          //hideOverlay();
          if (result.error) {
            showErrorMessage(result.error);
            return;
          } else {
            Pusher.refresh(result.unread);
          }
        },
        error: function (response) {
          console.error("RESULT", response);
          var result = response.responseJSON;
          //hideOverlay();
          showErrorMessage(errorMessage(result));
        }
      });
    },
    markAsRead: function (id, date) {
      if (id)
        $('[data-message-id=' + id + ']').removeClass('unread');
      $.ajax({
        type: "POST",
        url: id ? ('/messages/' + id) : '/messages',
        data: {
          read_at: 1,
          f_date: date
        },
        dataType: "json",
        success: function (result) {
          //hideOverlay();
          if (result.error) {
            showErrorMessage(result.error);
            return;
          } else {
            Pusher.refresh(result.unread);
          }
        },
        error: function (response) {
          console.error("RESULT", response);
          var result = response.responseJSON;
          //hideOverlay();
          showErrorMessage(errorMessage(result));
        }
      });
    },
    onclick: function (notification) {
      return function (e) {
        Pusher.markAsRead(notification.id);
        //console.log(notification);
      }
    },
    connect: function (id) {
      if (window.Echo) {
        window.Echo.private('accounts-' + id + '')
          .notification((notification) => {
            // console.log(notification);
            if (notification.type === "App\\Notifications\\AppNotification" ||
              notification.type === "App\\Notifications\\AdminNotification") {
              toastr.success(notification.message, notification.subject, {
                closeButton: true,
                timeOut: 8000,
                extendedTimeOut: 0,
                onclick: Pusher.onclick(notification),
                onCloseClick: Pusher.onclick(notification),
              });
              Pusher.load();
              $("#new-messages").show();
            }
            if (notification.additional) {
              switch (notification.additional.type) {
                case "CollectionReady":
                  onCollectionPublishChange(notification.additional.collectionId, 'published');
                  //console.warn("TODO: CollectionReady", notification.additional.collectionId, notification.additional.shopId);
                  break;
                case "CollectionStart":
                  onCollectionPublishChange(notification.additional.collectionId, 'publishing');
                  //console.warn("TODO: CollectionStart", notification.additional.collectionId, notification.additional.shopId);
                  break;
                case "CollectionFailed":
                  onCollectionPublishChange(notification.additional.collectionId, 'failed', notification.additional);
                  //console.warn("TODO: CollectionFailed", notification.additional.message, notification.additional.code, notification.additional.collectionId, notification.additional.shopId);
                  break;
                case "ProductStart":
                  onProductPublishChange(notification.additional.productId, 'publishing');
                  //console.warn("TODO: ProductStart", notification.additional.productId, notification.additional.collectionId, notification.additional.shopId);
                  break;
                case "ProductReady":
                  onProductPublishChange(notification.additional.productId, 'published');
                  //console.warn("TODO: ProductReady", notification.additional.productId, notification.additional.collectionId, notification.additional.shopId);
                  break;
                case "ProductFailed":
                  onProductPublishChange(notification.additional.productId, 'modified');
                  //console.warn("TODO: ProductFailed", notification.additional.message, notification.additional.code, notification.additional.productId, notification.additional.collectionId, notification.additional.shopId);
                  break;
              }
            }
          });
      }
    },
    refresh: function (c) {
      $('.js-unread-counter').text(c);
      if (!c)
        $('.badge.js-unread-counter').hide();
      else
        $('.badge.js-unread-counter').show();
    }
  };

/**
 *
 * @param collectionId
 * @param {('published'|'publishing'|'failed')} publishStatus
 * @param {{code: number, message: string}} [data]
 */
function onCollectionPublishChange(collectionId, publishStatus, data) {
  var editCollectionBtn = $('.edit-collection-btn[data-id="' + collectionId + '"]');
  // set to default
  $('[data-publishing-limited]').attr('data-publishing-limited', '');
  $('[data-publishing-status]').attr('data-publishing-status', '');

  if (publishStatus === 'publishing') {
    editCollectionBtn.attr('data-progress', '1').attr('title', editCollectionBtn.data('btn-in-progress-title'));
    $('[data-publishing-status]').attr('data-publishing-status', 'publishing');
  } else {
    editCollectionBtn.attr('data-progress', '0').attr('title', editCollectionBtn.data('btn-default-title'));
    if (publishStatus === "failed") {
      if (data) {
        if ((+data.code === ERROR_SKU_LIMIT_REACHED || +data.code === ERROR_API_LIMIT_REACHED)) { // limiter
          $('[data-publishing-limited]').attr('data-publishing-limited', 1);
        } else { // stopper
          $('[data-publishing-status]').attr('data-publishing-status', 'stopped');
        }
        $('[data-publishing-status] .publish-error-text').text(data.message)
      }
    }
  }
}

/**
 *
 * @param collectionId
 * @param {('published'|'publishing')} publishStatus
 * @param {{code: number, message: string}} [data]
 */
function onProductPublishChange(productId, publishStatus, data) {
  $('#products-list [data-id="' + productId + '"]').attr('data-product-publishing-status', publishStatus)
}

function checkOutside($event) {
  var $container = $("#messages-box");
  var $container2 = $("#js-m-link");
  if (!$container2.is($event.target) && $container2.has($event.target).length === 0) {
    if (!$container.is($event.target) && $container.has($event.target).length === 0) {
      $container.hide();
      $(document).unbind("mouseup", checkOutside);
      $event.preventDefault();
      $event.stopImmediatePropagation();
    }
  }
}

var Payments =
  window.Payments = {
    initStripe: function (stripe) {
      if ($("#payment-form").length) {
        // Create an instance of Elements
        var elements = stripe.elements();

        var elementStyles = {
          base: {
            color: '#32325d',
            lineHeight: '18px',
            fontSmoothing: 'antialiased',
            '::placeholder': {
              color: '#aab7c4'
            }
          },
          invalid: {
            color: '#58666E',
            iconColor: '#fa755a'
          }
        };

        var elementClasses = {
          focus: 'focus',
          empty: 'empty',
          invalid: 'invalid',
        };

        var cardNumber = elements.create('cardNumber', {
          style: elementStyles,
          classes: elementClasses,
        });
        cardNumber.mount('#billing-card-number');

        var cardExpiry = elements.create('cardExpiry', {
          style: elementStyles,
          classes: elementClasses,
        });
        cardExpiry.mount('#billing-card-expiry');

        var cardCvc = elements.create('cardCvc', {
          style: elementStyles,
          classes: elementClasses
        });
        cardCvc.mount('#billing-card-cvc');

        // Handle real-time validation errors from the card Element.
        cardNumber.addEventListener('change', function (event) {
          $('#card-errors').text(event.error ? event.error.message : '');
        });

        //var cardholderName = document.getElementById('cardholder-name');
        $("#card-button").on("click", function ($event) {
          $event.preventDefault();

          $('#card-errors').text('');
          stripe.confirmCardSetup(
            $(this).data('secret'), {
              payment_method: {
                card: cardNumber,
                // billing_details: {
                //     name: cardholderName.value,
                // },
              },
            }
          ).then(function (result) {
            //console.log(result);
            if (result.error) {
              //hideOverlay();
              // Display error.message in your UI.
              $('#card-errors').text(result.error.message);
            } else {
              showOverlay();
              // The setup has succeeded. Display a success message.
              $.ajax({
                type: "POST",
                url: '/billing/stripe',
                data: result.setupIntent,
                dataType: "json",
                success: function (result) {
                  if (result.error) {
                    hideOverlay();
                    showErrorMessage(result.error);
                  } else {
                    window.location.reload();
                  }
                },
                error: function (response) {
                  console.error("RESULT", response);
                  var result = response.responseJSON;
                  hideOverlay();
                  showErrorMessage(errorMessage(result));
                }
              });
            }
          });
        });

        // $('#payment-form').on('submit', function($event){
        //     $event.preventDefault();
        //     showOverlay();
        //     stripe.createToken(cardNumber, cardCvc, cardExpiry).then(function (result) {
        //         if (result.error) {
        //             $.ctrl.hideOverlay();
        //             // Inform the user if there was an error
        //             var errorElement = document.getElementById('card-errors');
        //             errorElement.textContent = result.error.message;
        //         } else {
        //             // Send the token to your server
        //             $.ajax({
        //                 type: "POST",
        //                 url: '/billing/stripe',
        //                 data: result.token,
        //                 dataType: "json",
        //                 success: function (result) {
        //                     if (result.error) {
        //                         hideOverlay();
        //                         showErrorMessage(result.error);
        //                     } else {
        //                         window.location.reload();
        //                     }
        //                 },
        //                 error: function (response) {
        //                     console.error("RESULT", response);
        //                     var result = response.responseJSON;
        //                     hideOverlay();
        //                     showErrorMessage(errorMessage(result));
        //                 }
        //             });
        //         }
        //     });
        // });
      }
    },
    removeCard: function (service) {
      showOverlay();
      $.ajax({
        type: "DELETE",
        url: "/billing/" + service,
        dataType: "json",
        success: function (result) {
          if (result.error) {
            hideOverlay();
            showErrorMessage(result.error);
          } else {
            window.location.reload();
          }
        },
        error: function (response) {
          console.error("RESULT", response);
          var result = response.responseJSON;
          hideOverlay();
          showErrorMessage(errorMessage(result));
        }
      });
    },
    // pay: function (service, amount) {
    //     showOverlay();
    //     $.ajax({
    //         type: "POST",
    //         url: "/billing/pay",
    //         data: {
    //             with: service,
    //             amount: amount
    //         },
    //         dataType: "json",
    //         success: function (result) {
    //             hideOverlay();
    //             if (result.error) {
    //                 showErrorMessage(result.error);
    //             } else {
    //                 window.showSuccessMessage(result.message, '', 'OK', function(){
    //                     window.location.reload();
    //                 });
    //             }
    //         },
    //         error: function (response) {
    //             console.error("RESULT", response);
    //             var result = response.responseJSON;
    //             hideOverlay();
    //             showErrorMessage(errorMessage(result));
    //         }
    //     });
    // },
    pay: function (service, amount) {
      showOverlay();
      $.ajax({
        type: "POST",
        url: "/billing/prepare",
        data: {
          with: service,
          amount: amount
        },
        dataType: "json",
        success: function (result) {
          hideOverlay();
          if (result.error) {
            showErrorMessage(result.error);
          } else {
            Payments.confirm(service, result)
          }
        },
        error: function (response) {
          console.error("RESULT", response);
          var result = response.responseJSON;
          hideOverlay();
          showErrorMessage(errorMessage(result));
        }
      });
    },
    confirm: function (service, data) {
      if (service === 'stripe') {
        stripe.confirmCardPayment(
          data.key, data.failed ? {payment_method: data.failed} : {}
        ).then(function (result) {
          //console.log(result);
          if (result.error) {
            //showErrorMessage(result.error.message);
            showErrorMessage(result.error.message, null, null, function () {
              window.location.reload();
            });
          } else {
            if (result.paymentIntent.status === 'succeeded') {
              // The payment is complete!

              $.ajax({
                type: "POST",
                url: "/billing/confirm",
                data: {
                  with: service,
                  id: result.paymentIntent.id
                },
                dataType: "json",
                success: function (result) {
                  hideOverlay();
                  if (result.error) {
                    showErrorMessage(result.error, null, null, function () {
                      window.location.reload();
                    });
                  } else {
                    showSuccessMessage(result.message, '', 'OK', function () {
                      window.location.reload();
                    });
                  }
                },
                error: function (response) {
                  console.error("RESULT", response);
                  var result = response.responseJSON;
                  hideOverlay();
                  showErrorMessage(errorMessage(result), null, null, function () {
                    window.location.reload();
                  });
                }
              });

            } else {
              //showErrorMessage("Status " + result.paymentIntent.status);
              showErrorMessage("Status " + result.paymentIntent.status, null, null, function () {
                window.location.reload();
              });
            }
          }
        });
      }
    }
  };

var App =
  window.App = {
    confirm: null,
    uac: function (callback) {
      App.confirm = callback;
      $('#old-password').attr('name', 'password').attr('type', 'password');
      $('#password-dialog').modal();
    }
  };

window.markFieldAsInvalid = function (fieldSelector, errorMsg, fieldsSelectorToClearErrorOnInput) {
  $(fieldSelector).addClass('is-invalid');
  $(fieldSelector).after(`
    <span class="error" role="alert">
        <strong>${errorMsg}</strong>
    </span>
    `);
  if (fieldsSelectorToClearErrorOnInput) {
    $(fieldsSelectorToClearErrorOnInput).one('input', function () {
      $(fieldsSelectorToClearErrorOnInput).removeClass('is-invalid');
      $(fieldsSelectorToClearErrorOnInput).nextAll('.error').remove();
    });
  }
}

$(function () {
  bsCustomFileInput.init();
  $("select.select2").select2({width: "100%"});
  $("a[data-method]").useForm();
  $(".use-js-yscroll").mCustomScrollbar({
    theme: "minimal-dark",
    axis: "y"
  });
  $(".use-js-hscroll").mCustomScrollbar({
    theme: "minimal-dark",
    axis: "x"
  });

  function setLeftCharsInField() {
    var lettersLength = $(this).val().length;
    var ref = $(this).data('count-ref');
    $("#" + ref).text(lettersLength);
  }

  // all .input-symbols-count are hidden by default. show it after js loaded
  $('.input-symbols-count').addClass('js-init');
  $('.js-field-count').on('keyup change', setLeftCharsInField).each(setLeftCharsInField);

  $('.magnific').magnificPopup({
    type: "image",
    closeBtnInside: true,
    closeMarkup: '',
    closeOnContentClick: true,
    fixedContentPos: true,
    mainClass: 'mfp-no-margins mfp-with-zoom',
    image: {
      verticalFit: true,
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
    }
  });
  $('.magnificList').magnificPopup({
      delegate: 'a.image',
      type: 'image',
      mainClass: 'mfp-no-margins mfp-with-zoom',
      gallery: {
          enabled: true,
          navigateByImgClick: true
      },
      image: {
          verticalFit: true,
          tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
      }
  });

  $("#change-title-dialog .js-restore, #change-description-dialog .js-restore").on('click', function ($event) {
    $event.preventDefault();
    var $modal = $(this).closest('.modal-dialog');
    $modal.find("[name=value]").val($(this).data('default'));
  });

  $('[data-edit="title"], [data-edit="description"]').on('click', function ($event) {
    $event.preventDefault();

    var $target = $(this);
    var type = $(this).data('edit');
    var def = $(this).data('default');
    var primary = $(this).data('primary');
    var $modal = $("#change-" + type + "-dialog");
    var id = $(this).data('product');

    if (type === 'description') {
      $modal.find(".product-name").text($('[data-edit="title"]').attr('data-value'));
    }

    $modal.modal('show');
    //$modal.find("[name=value]").val(+$(this).data('empty') ? $(this).data('default') : $(this).data('value'));
    $modal.find("[name=value]").val($(this).data('value'));
    $modal.find("[name=default]").prop('checked', +$(this).data('empty') || +$(this).data('primary'));
    $modal.find(".js-restore").data('default', def);
    if (primary) {
      $modal.find(".form-check").hide();
      $modal.find(".form-default").show();
    } else {
      $modal.find(".form-default").hide();
      $modal.find(".form-check").show();
    }
    $modal.find("[name=save]").unbind("click").on("click", function () {
      var val = $modal.find("[name=value]").val().trim();
      var empty = 0;
      if (val === "" || val === def) {
        val = "";
        empty = 1;
      }

      if ((!empty || primary) && $modal.find("[name=default]").is(':checked')) {
        if (!primary) {
          empty = 1;
          def = val;
          $target.data('default', def);
        }

        showOverlay();
        saveDefaultTitleOrDescription(type, val, id, hideOverlay);
      }

      $target.data('empty', empty);
      $target.data('value', empty ? def : val);
      document.dispatchEvent(new CustomEvent("attributeUpdated", {
        "detail": {
          type: type, empty: empty, def: def, val: val, target: $target
        }
      }));
      $modal.modal('hide');
    });
  });

  $('[data-toggle="popover"]').popover();

  $('#js-m-link').on('click', function ($event) {
    $event.preventDefault();
    if ($("#messages-box").is(":visible")) {
      $("#messages-box").hide();
      $(document).unbind("mouseup", checkOutside);
    } else {
      $("#messages-box [data-time]").each(function () {
        $(this).text(moment.unix($(this).data('time')).fromNow());
      });

      $("#messages-box").show();
      $(document).on("mouseup", checkOutside);
      //Pusher.load();
    }
  });

  $("#messages-box").on("mouseenter", ".unread", function ($event) {
    $(this).removeClass('unread');
    Pusher.markAsRead($(this).data('message-id'));
  });

  /*$("#messages-box").on("click", "[data-delete]", function($event){
      $event.preventDefault();
      Pusher.delete($(this).data('delete'));
  });*/

  $('#password-dialog').find("[name=save]").on("click", function ($event) {
    $event.preventDefault();

    if (!$('#password-dialog [name=password]').val()) {
      $('#password-dialog [name=password]').addClass('is-invalid');
      return;
    }

    $('#password-dialog').modal('hide');
    if (App.confirm !== null)
      App.confirm($('#password-dialog [name=password]'));
  });

  $('.button-with-options').on('click', function ($event) {
    if (!$event.target.matches('.button-with-options .options-list *')) {
      $event.preventDefault();
    }
    $event.stopPropagation();
    $(this).toggleClass('active');
    if ($(this).hasClass('active')) {
      const btn = $(this);
      $(document).one('click', function () {
        btn.removeClass('active');
      })
    }
  });

  // show eye icon to show/hide a password
  $('.password-input-container').each(function () {
    var passwordInputContainer = $(this);
    var passwordInput = passwordInputContainer.find('input');
    var toggler = jQuery('<div>', {
      class: 'show-password-toggle'
    }).click(function () {
      passwordInputContainer.toggleClass('show-password');
      passwordInput.attr('type', passwordInputContainer.hasClass('show-password') ? 'text' : 'password');
    });
    passwordInputContainer.append(toggler);
    passwordInputContainer.toggleClass('password-filled', !!passwordInput.val());
    passwordInput.on('input', function () {
      passwordInputContainer.toggleClass('password-filled', !!$(this).val());
    })
  })
});

/**
 *
 * @param {Function} f
 * @param {boolean} shouldExecute
 * @param {'last' | number | null} successCallbackIndexInArguments
 * @returns {function(...[*]=)}
 */
window.executeOrCallSuccessCallbackDecorator = function (f, shouldExecute, successCallbackIndexInArguments = 'last') {
  return function () {
    if (shouldExecute) {
      f.apply(this, arguments);
    } else {
      var callbackIndex = successCallbackIndexInArguments === 'last' ? arguments.length - 1 : successCallbackIndexInArguments;
      var successCallback = callbackIndex !== null && arguments[callbackIndex];
      if (successCallback && typeof successCallback === "function") {
        successCallback();
      }
      return;
    }
  }
}

window.saveDefaultTitleOrDescription = function (type, value, productId, successCallback) {
  $.ajax({
    type: "POST",
    url: '/preferences/' + productId,
    data: {
      [type]: value
    },
    dataType: "json",
    success: function (result) {
      if (result.error) {
        hideOverlay();
        showErrorMessage(result.error);
        return;
      } else {
        if (successCallback && typeof successCallback === "function") {
          successCallback();
        }
        //
      }
    },
    error: function (response) {
      console.error("RESULT", response);
      var result = response.responseJSON;
      hideOverlay();
      showErrorMessage(errorMessage(result));
    }
  });
}

window.shortenString = function (str, maxLength, cutFromEnd) {
  if (cutFromEnd) {
    return str.toString().slice(0, maxLength);
  } else { // cut from middle
    var halfOfMaxLength = Math.floor(maxLength / 2);
    return str.length > maxLength ? (str.substr(0, halfOfMaxLength) + "…" + str.substr(str.length - (maxLength - halfOfMaxLength) + 1)) : str;
  }
}

let localStorageExists = typeof localStorage !== 'undefined';
if (localStorageExists) {
  try {
    localStorage.setItem('testLS', '1');
  } catch (e) {
  }
  localStorageExists = localStorage.getItem('testLS') === '1';
  if (localStorageExists) {
    localStorage.removeItem('testLS');
  }
}

window.setInStorage = function (key, value) {
  if (localStorageExists) {
    localStorage.setItem(key, value)
  }
}

window.getFromStorage = function (key) {
  if (localStorageExists) {
    return localStorageExists && localStorage.getItem(key)
  }
}

window.showToastErrorMessage = function (message, multi) {
  if (multi)
    toastr.error(escapeHtml(message).split("\n").join("<br />"));
  else
    toastr.error(escapeHtml(message));
}

window.isValidEmail = function (email) {
  var validRegex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
  return !!email.match(validRegex);
}

require("./editor");
